module.exports = __webpack_public_path__ + "static/Lato-SemiboldItalic-9fcec04cdba9253e002e740a7cd743fe.woff";